import type { RootState } from "~/app/store";
import { type ConfiguratorProductData, ProductType } from "~/domains/product/types/ProductData";
import { type ImageDataDTO, ImageFormat, ImageType } from "~/domains/product/types/ProductDataDTO";
import { selectProductImageUrl } from "~/features/configurator/common/components/ConfigurationSummarySubstep";
import { useXmlConfiguratorTranslations } from "~/features/configurator/common/useXmlConfiguratorTranslations";
import type { WithTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getLinearProductDescriptions } from "./linearProductDescription";

export const useLinearProductInfo = (): ConfiguratorProductData => {
  const xmlT = useXmlConfiguratorTranslations().t;
  return useSelector(selectLinearProductInfo(xmlT!));
};

const selectLinearProductInfo =
  (xmlT: WithTranslation["t"]) =>
  (state: RootState): ConfiguratorProductData => {
    const sapMaterialNumber = state.linearConfigurator.schaefflerId;
    const designation = state.linearConfigurator.designation;
    const description = state.linearConfigurator.description;
    const code = state.linearConfigurator.productCode;
    const configuratorType = state.linearConfigurator.type!;
    const descriptions = getLinearProductDescriptions(description, xmlT);

    const images: ImageDataDTO[] = [];
    const imgUrl = selectProductImageUrl(state);
    if (imgUrl) {
      images.push({
        format: ImageFormat.thumbnail,
        imageType: ImageType.primary,
        url: xmlT!(imgUrl),
        altText: designation,
      });
    }

    const data: ConfiguratorProductData = {
      code: code,
      hybrisCode: code,
      pnaCode: code,
      configuratorType,
      designation,
      description: descriptions.description,
      images,
      sapMaterialNumber,
      url: "",
      shortDescription: descriptions.shortDescription,
      baseType: "",
      aliases: [],
      packageAliases: {},
      productAllCategories: [],
      productLineId: "",
      type: ProductType.CONFIGURATOR,
      subtype: "part",
      configId: state.linearConfigurator.configId,
      leadTime: 0,
      guideway: "",
      carriages: "",
      isOptime: false,
      quantityVisible: true,
      marketType: null,
      isPMA: false,
      gpsdGroup: null,
      alternativeProducts: [],

      features: [],
      technicalDetails: [],
      numberOfBolts: "",
      configuratorTypes: [],
      fifteenDigit: {},
      salesCampaign: {},
      marketDesignation: "",
      cmnSearchMatched: false,
      displayMMDAssistant: false,
      stockAmount: 0,

      predecessorProducts: [],
      categoryName: "",
    };

    return data;
  };
